// extracted by mini-css-extract-plugin
var _1 = "ra-menu-vertical";
var _2 = "ra-menu-vertical-item";
var _3 = "ra-menu-vertical-container";
var _4 = "ra-menu-vertical-item-icon";
var _5 = "ra-menu-vertical-item-opened";
var _6 = "ra-menu-vertical-prefix";
var _7 = "ra-menu-vertical-submenu";
var _8 = "ra-menu-vertical-submenu-item";
export { _1 as "menuVerticalCls", _2 as "menuVerticalItemCls", _3 as "menuVerticalItemContainerCls", _4 as "menuVerticalItemIconCls", _5 as "menuVerticalItemOpenedCls", _6 as "menuVerticalItemPrefixCls", _7 as "menuVerticalSubmenuCls", _8 as "menuVerticalSubmenuItemCls" }
